export default __webpack_public_path__ + "static/media/person.45739f6b.png";